function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.06 11.82l-.16-.22c-.28-.34-.61-.61-.99-.81-.51-.29-1.09-.44-1.69-.44H5.77c-.6 0-1.17.15-1.69.44-.39.21-.74.5-1.03.86-.57.73-.84 1.63-.75 2.53l.37 4.67c.13 1.41.3 3.15 3.47 3.15h11.72c3.17 0 3.33-1.74 3.47-3.16l.37-4.65c.09-.84-.13-1.68-.64-2.37zm-6.67 5.52H9.6c-.39 0-.7-.32-.7-.7 0-.38.31-.7.7-.7h4.79c.39 0 .7.32.7.7 0 .39-.31.7-.7.7z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M3.38 11.31c.22-.2.44-.38.7-.52.51-.29 1.09-.44 1.69-.44h12.46c.6 0 1.17.15 1.69.44.26.14.49.32.7.53v-1.5c0-3.57-1.09-4.66-4.66-4.66h-2.38c-.44 0-.45-.01-.71-.35l-1.2-1.61C11.1 2.46 10.65 2 9.22 2H8.04C4.47 2 3.38 3.09 3.38 6.66v4.65z"
})));